import { useEffect, useRef } from 'react'
import { useEditorStore } from './store/editorStore'
import { ProjectList } from './components/projects/ProjectList'
import { EditorScreen } from './components/editor/EditorScreen'

export default function App() {
  const screen = useEditorStore((s) => s.screen)
  const openProject = useEditorStore((s) => s.openProject)
  const openedFromDeepLink = useRef(false)

  // docs/COMPOSER_CONTRACT.md §6.1: `?project=<id>&composition=<id>` opens
  // that project/composition directly (used by ComposerDraft.studioUrl —
  // "スタジオで確認する"). Runs once on mount; a bare `?project=` with no
  // `composition` just opens the project's default Composition (openProject's
  // own existing fallback).
  useEffect(() => {
    if (openedFromDeepLink.current) return
    openedFromDeepLink.current = true
    const params = new URLSearchParams(window.location.search)
    const projectId = params.get('project')
    if (!projectId) return
    const compositionId = params.get('composition') ?? undefined
    void openProject(projectId, compositionId)
  }, [openProject])

  return screen === 'editor' ? <EditorScreen /> : <ProjectList />
}
